import React from 'react';
import ReactDOM from 'react-dom/client';

/* Sprint 5 client feedback 2026-07-07 (UI Issues #8) — bundle the
 * typography-standardised fonts locally via @fontsource so the app
 * renders identically across every browser regardless of what system
 * fonts happen to be installed.
 *
 *   * Inter (variable) — the ONE UI family: body, tables, forms,
 *     headings, KPI values, hero copy
 *   * JetBrains Mono (variable) — IDs, refs, audit IDs, technical
 *     identifiers only
 *
 * Sprint 5 client feedback 2026-07-12 — 'Instrument Serif' dropped.
 * It was the display face for KPI values and hero copy, but it read as
 * narrow and congested beside Inter and made those figures look like a
 * different product from the text around them. Removing the import
 * also takes its woff2 out of the bundle — the font can no longer be
 * used by accident.
 *
 * Imports run once at app entry so Vite bundles the woff2 files into
 * the shipped assets — no external network calls at runtime, matching
 * the on-prem deployment posture. */
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';

import './index.css';
import App from './App';
import { initThemeFromStorage } from './hooks/useTheme';

/* Sprint 5 — apply the persisted theme before the first React render
 * so users do not see a light-theme flash on a dark-mode reload. */
initThemeFromStorage();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
